import React, { useState, useEffect } from "react";

import "./section-what-is-points.scss";
import Button from "../../../shared/components/atoms/button/button";
import ModalAcumulationPoints from "../modal-acumulation-points/modal-acumulation-points";
import {getTextButtonLearnMore, getTextForPointDescription} from "../../../utils/getPointMessages";
import { withBottomLine } from "../../../shared/utils/formatString";
import { buttonClickTransversal } from "../../../utils/loyaltyDatalayer";

const SectionWhatIsPoints = props => {

  const { mobile, isLogin, category = "mis_puntos" } = props

  const [pageLoad, setPageLoad] = useState(false)
  const [whatispoint, setwhatispoint] = useState(false)

  useEffect(() => {
    setPageLoad(true)
  }, [])

  if (pageLoad && mobile && !whatispoint) {
    setwhatispoint(true);
    setTimeout(() => {
      window.scrollTo(0, 700);
    }, 200);
  };

  if (pageLoad && !mobile && !whatispoint) {
    setwhatispoint(true);
    setTimeout(() => {
      window.scrollTo(0, 496);
    }, 200);
  };

  const handleShowModal =()=>{
    buttonClickTransversal({
      category: withBottomLine(category),
      label: getTextButtonLearnMore(process.env.LOCALE)
    });

    props.setModalActive(<ModalAcumulationPoints setModalClose={props.setModalActive}/>)
  }

  return (
    <div className={"f-section-what-is-points-container" + (isLogin ? ' f-back-login' : '')}>

      {(!isLogin && !mobile) && <span className="f-circle">
        <span className="f-circle-child" />
      </span>}

      {/* {!isLogin && <span className="f-curve-effect-what-is-point" />} */}

      <div className={"f-section-what-is-points-container-wrap"}>
        <div className={`f-image-what-is-points`} />
        <div className="f-info-container">
          <div className="f-info-container-title">
            <h2>
              ¿Qué son los puntos?
            </h2>
          </div>
          <div className="f-info-container-description">            
            <p>{getTextForPointDescription(process.env.LOCALE)}</p>            
          </div>
          {!isLogin ? 
            <Button 
              className="secondary-pink"
              onClick={handleShowModal}
              title={getTextButtonLearnMore(process.env.LOCALE)} />
            : 
            <Button 
              onClick={handleShowModal}
              className="primary-pink"
              title={getTextButtonLearnMore(process.env.LOCALE)} 
            />}
        </div>
      </div>

      {isLogin &&
        <span className={"f-curve-effect-end-section f-back-curve-login"}>
          <span className="f-curve-effect-end-section-child" />
        </span>
      }

    </div>
  )
}

export default SectionWhatIsPoints;
